import _ from "lodash";


class StateCountUtil {
    static getStateCount = (stats, stateName, workflowId) => {
        let loggedInUser = JSON.parse(sessionStorage.getItem("loggedInUser"));
        if (stats) {
            stats = stats.filter(function (el) {
                return loggedInUser.workflowList.some(
                    item => item.workflow.workflowId.toString() === el.workflowId
                );
            });
        }

        if ("All_Applications" === stateName || "My_Cases" === stateName) {
            // First try to find the specific state name in the stats
            let statObj = _.find(stats, {
                stateName: stateName,
                workflowId: workflowId.toString()
            });

            if (statObj && statObj["count"] > 0) {
                return statObj["count"];
            }

            // If not found or count is 0, fall back to old logic (sum all states)
            let sum = 0;
            let filteredStats;
            if (stats) {
                filteredStats = stats.filter(
                    i => i.workflowId === workflowId.toString() && !i.customState
                );
            }
            _.forEach(filteredStats, n => {
                sum += n["count"];
            });
            return sum;
        }

        // For all other state names, use the existing logic
        let statObj = _.find(stats, {
            stateName: stateName,
            workflowId: workflowId.toString()
        });
        if (statObj) {
            return statObj["count"];
        }

        return 0;
    };

    static getStateIcon = (stats, stateName, workflowId) => {
        let statObj = _.find(stats, {
            stateName: stateName,
            workflowId: workflowId.toString()
        });
        if (statObj) {
            return statObj["stateIcon"];
        }

        return null;
    };
}


export default StateCountUtil;